var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',{staticClass:"mt-4"},[_c('b-card-body',{staticClass:"p-2"},[(_vm.charttype == 'line')?_c('div',[_c('line-chart',{attrs:{"xyfiellds":_vm.xyfiellds,"title":_vm.title,"url":_vm.url}})],1):_vm._e()])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }